import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#006C5B",
      d: "M18.094.516C16.74.204 14.515 0 12 0S7.26.204 5.906.516a6.99 6.99 0 0 0-5.39 5.39C.204 7.26 0 9.485 0 12s.204 4.74.516 6.094a6.99 6.99 0 0 0 5.39 5.39C7.26 23.796 9.485 24 12 24s4.74-.204 6.094-.516a6.99 6.99 0 0 0 5.39-5.39C23.796 16.74 24 14.515 24 12s-.204-4.74-.516-6.094a6.99 6.99 0 0 0-5.39-5.39"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M7.25 11a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 .75.75H16l.75.001v.024a2 2 0 0 1-.011.175 3.8 3.8 0 0 1-.615 1.716c-.656.984-1.906 1.834-4.124 1.834s-3.468-.85-4.124-1.834a3.8 3.8 0 0 1-.615-1.716 3 3 0 0 1-.01-.175v-.015l-.001-.005zv.004zm1.69.75q.073.165.184.334c.344.516 1.095 1.166 2.876 1.166s2.532-.65 2.876-1.166q.112-.17.183-.334zM5.653 8.368l.003-.004.014-.024A4 4 0 0 1 6 7.873l.073.089a4 4 0 0 1 .257.378l.014.024.003.005a.75.75 0 0 0 1.307-.737L7 8l.654-.368-.001-.001v-.002l-.003-.003-.007-.013a4 4 0 0 0-.105-.172 5 5 0 0 0-.283-.403 3 3 0 0 0-.439-.461C6.664 6.45 6.376 6.25 6 6.25s-.664.201-.816.327a3 3 0 0 0-.438.461 5 5 0 0 0-.389.575l-.007.013-.002.003v.002L5 8l-.653-.368a.75.75 0 0 0 1.306.736m.517-.656-.01.005zm-.33.005-.01-.005zm11.814.651.002-.004.014-.024.058-.094A4 4 0 0 1 18 7.873l.073.089a4 4 0 0 1 .257.378l.014.024.003.005a.75.75 0 0 0 1.307-.737L19 8l.654-.368-.001-.001v-.002l-.003-.003-.007-.013a4 4 0 0 0-.105-.172 5 5 0 0 0-.283-.403 3 3 0 0 0-.439-.461c-.152-.126-.44-.327-.816-.327s-.664.201-.816.327a3 3 0 0 0-.439.461 5 5 0 0 0-.388.575l-.007.013-.002.003v.002L17 8l-.653-.368a.75.75 0 0 0 1.306.736m.515-.656-.01.005zm-.329.005-.01-.005z",
      clipRule: "evenodd"
    }
  )
);
var SvgSentimentPositiveFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SentimentPositiveFilled_default = SvgSentimentPositiveFilled;

export { SentimentPositiveFilled_default as default };
